module.exports = __webpack_public_path__ + "static/img/herobox.0c868bbf.png";